import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19273 19218"
    {...props}
  >
    <defs>
      <style>
        {
          //   ".str0{stroke:#000;stroke-width:279.319;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528316982784">
        <path
          d="M1025 515h17321M926 515c0 207-176 375-393 375S140 722 140 515s176-375 393-375 393 168 393 375zM19133 515c0 207-176 375-393 375-218 0-394-168-394-375s177-375 394-375 393 168 393 375zM3769 16580c296 0 296 83 592 83s296-83 592-83 296 83 592 83 296-83 592-83 296 83 592 83 296-83 592-83 296 83 592 83M2249 770s-379 5593 2331 8803M9320 770s379 5593-2331 8803M4317 9696h2810v1000H4317zM7913 16621l-872-5910M4513 10723l-731 5794M10208 770s-359 5593 2210 8803M16913 770s359 5593-2211 8803M12169 9696h2664v1000h-2664zM15579 16621l-827-5910M11650 16582c280 0 280 79 561 79 280 0 280-79 561-79s281 79 561 79c281 0 281-79 562-79 280 0 280 79 561 79s281-79 562-79c280 0 280 79 561 79M12355 10723l-693 5794"
          className="fill-none stroke1"
          style={{
            strokeWidth: 279.319,
            strokeLinecap: "round",
          }}
        />
        <path
          d="M17544 770v18308c-423 0-540-346-963-346s-305 346-728 346-423-358-845-358c-421 0-421 358-842 358-422 0-422-358-844-358-421 0-421 358-843 358-420 0-420-358-841-358-422 0-422 358-843 358-420 0-420-358-840-358-421 0-421 358-843 358-421 0-421-358-842-358s-421 358-842 358-421-358-843-358c-420 0-420 358-841 358s-421-358-843-358c-420 0-420 358-841 358-420 0-420-358-841-358s-421 358-841 358c-421 0-842-179-842-179V770M5422 9555l-490-1150M6401 9555l374-1150M13182 9555l-489-1150M14162 9555l374-1150"
          className="fill-none stroke1"
          style={{
            strokeWidth: 279.319,
            strokeLinecap: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
